// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HierarchyPanel - Instance hierarchy tree */

.hierarchy-row {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 12px;
  line-height: 1.4;
  border-left: 2px solid transparent;
}

.hierarchy-row:hover {
  background: var(--color-ide-surface-2);
}

.hierarchy-row-readonly {
  cursor: default;
  opacity: 0.8;
}

.hierarchy-row-selected {
  background: var(--color-ide-selection-bg);
  color: var(--color-ide-selection-text);
  border-left-color: var(--color-ide-accent);
}

.hierarchy-name {
  color: var(--color-ide-text);
  white-space: nowrap;
  flex-shrink: 0;
}

.hierarchy-target {
  color: var(--color-ide-text-dim);
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
  min-width: 0;
  margin-left: auto;
  padding-left: 8px;
}

.hierarchy-loading {
  font-size: 11px;
  color: var(--color-ide-text-dim);
  padding: 2px 8px;
  font-style: italic;
}

.hierarchy-empty {
  padding: 12px;
  text-align: center;
  color: var(--color-ide-text-dim);
  font-size: 12px;
}

.hierarchy-count {
  font-size: 10px;
  color: var(--color-ide-text-dim);
  margin-left: 4px;
}

/* Search results layout */

.hierarchy-search-result {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px;
  min-width: 0;
  flex: 1;
}

.hierarchy-search-path {
  width: 100%;
  font-size: 10px;
  color: var(--color-ide-text-dim);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.hierarchy-search-info {
  padding: 4px 12px;
  font-size: 11px;
  color: var(--color-ide-text-dim);
  font-style: italic;
  border-bottom: 1px solid var(--color-ide-border);
}
`, "",{"version":3,"sources":["webpack://./src/components/HierarchyPanel/hierarchyPanel.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,0BAA0B;;AAE1B;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gDAAgD;AAClD","sourcesContent":["/* HierarchyPanel - Instance hierarchy tree */\n\n.hierarchy-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  cursor: pointer;\n  user-select: none;\n  font-size: 12px;\n  line-height: 1.4;\n  border-left: 2px solid transparent;\n}\n\n.hierarchy-row:hover {\n  background: var(--color-ide-surface-2);\n}\n\n.hierarchy-row-readonly {\n  cursor: default;\n  opacity: 0.8;\n}\n\n.hierarchy-row-selected {\n  background: var(--color-ide-selection-bg);\n  color: var(--color-ide-selection-text);\n  border-left-color: var(--color-ide-accent);\n}\n\n.hierarchy-name {\n  color: var(--color-ide-text);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.hierarchy-target {\n  color: var(--color-ide-text-dim);\n  font-size: 11px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex-shrink: 1;\n  min-width: 0;\n  margin-left: auto;\n  padding-left: 8px;\n}\n\n.hierarchy-loading {\n  font-size: 11px;\n  color: var(--color-ide-text-dim);\n  padding: 2px 8px;\n  font-style: italic;\n}\n\n.hierarchy-empty {\n  padding: 12px;\n  text-align: center;\n  color: var(--color-ide-text-dim);\n  font-size: 12px;\n}\n\n.hierarchy-count {\n  font-size: 10px;\n  color: var(--color-ide-text-dim);\n  margin-left: 4px;\n}\n\n/* Search results layout */\n\n.hierarchy-search-result {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 4px;\n  min-width: 0;\n  flex: 1;\n}\n\n.hierarchy-search-path {\n  width: 100%;\n  font-size: 10px;\n  color: var(--color-ide-text-dim);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2;\n}\n\n.hierarchy-search-info {\n  padding: 4px 12px;\n  font-size: 11px;\n  color: var(--color-ide-text-dim);\n  font-style: italic;\n  border-bottom: 1px solid var(--color-ide-border);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
